import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { LIVE_LINK } from '../helpers/url_helper'

export const catalogApi = createApi({
  reducerPath: 'catalogApi',
  baseQuery: fetchBaseQuery({ baseUrl: `${LIVE_LINK}/orders/order` }),
  tagTypes: ['products'],
  endpoints: (build) => ({
    fetchProducts: build.query({
      query: (id) => ({
        // url: '/'
        url: `/${id}`,
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.products.map(({ _id }) => ({ type: 'products', id: _id })), // Provide individual tags for each item
              { type: 'products', id: 'LIST' } // Special tag for the whole list
            ]
          : [{ type: 'products', id: 'LIST' }],
      refetchOnMountOrArgChange: true, // Add this line
    }),
    completeOrder: build.mutation({
      query: (newRow) => ({
        url: '/',
        method: 'POST',
        body: newRow
      })
    }),
  })
});